var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 615 675.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #244858;\n      }\n      .skin {\n        fill: #dcac8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.76,676H49.41c25-125.82,132.24-220.38,260.68-220.38S545.71,550.15,570.76,676Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M568.78,214.84C552.87,367,453.2,492.15,310.62,492.08,173,492,63.35,367.51,52.46,214.84,38.93,25,167.42,0,310,0S590.2,10,568.78,214.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M347.33,566.81c-17.72,28.46-59.45,27.58-75.94-1.62l-7.69-13.62-44.3-78.42,94-1.34,93.95-1.34-49.65,79.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 51,
    cy: 250,
    r: 51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 564,
    cy: 246,
    r: 51
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.2ee2eba9.svg";
export { ForwardRef as ReactComponent };